import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import NavLink from './navLink';
import List from './list';
import useMenuItems from '../../../hooks/use-menu-items';
import useActiveMenu from '../../../hooks/use-active-menu';

const ButtonWrapper = styled.div`
  @media all and (min-width: ${({ navBreakpoint }) => navBreakpoint}) {
    display: none;
  }
  button {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: transparent;
    border: none;
    padding: 0;
    margin-left: auto;
    text-transform: uppercase;
    color: ${({ theme }) => theme.pages.blockNav.buttonColor};
    font-size: .75rem;
    svg {
      width: 2.25rem;
    }
  }
`;
const ChildLink = styled(Link)`
  transition: all .2s;
  display: block;
  padding: .25rem 2rem .25rem 1rem;
  text-decoration: none;
  color: white;
  white-space: nowrap;
  &:hover {
    opacity: .8;
  }
`;
const Child = styled.li``;
const Children = styled.ul`
  transition: all .2s;
  position: absolute;
  z-index: 2;
  top: -100%;
  left: 0;
  opacity: 0;
  list-style: none;
  padding: .75rem 0;
  pointer-events: none;
  margin: 0;
  background-color: ${({ theme }) => theme.primaryColor};
  border-radius: 0 .25rem .25rem .25rem;
`;

// @TODO: use mouseIn and mouseOut, not hover. Copy from Gymstone
const Li = styled.li`
  position: relative;
  &:hover {
    position: relative;
    ${Children} {
      opacity: 1;
      top: calc(100% + -0.25rem);
      pointer-events: auto;
    }
  }
`;

const Nav = styled.nav`
  display: none;
  @media all and (min-width: ${({ navBreakpoint }) => navBreakpoint}) {
    display: block;
  }
`;

const BlockNav = ({
  setCoverOpen,
  navBreakpoint,
  activeClassName,
  className,
  pageId,
  mustHaveSubpages = true,
}) => {
  const { menuitems } = useMenuItems();
  // activeMenu is used to check if a page has active children and add active styling
  const activeMenu = useActiveMenu({ pageId, mustHaveSubpages });

  return (
    <>
      <ButtonWrapper navBreakpoint={navBreakpoint}>
        <button
          type="button"
          aria-label="Open menu"
          onClick={() => setCoverOpen(true)}
        >
          <svg
            aria-hidden="true"
            focusable="false"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path fill="currentColor" d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z" />
          </svg>
          Menu
        </button>
      </ButtonWrapper>

      <Nav className={className} navBreakpoint={navBreakpoint}>
        {menuitems && menuitems.length > 0 && (
          <List>
            {menuitems.map(({ id, page, subpage }) => page && (
              <Li key={id}>
                <NavLink
                  activeClassName={activeClassName}
                  className={activeMenu?.page?.slug === page.slug ? activeClassName : ''}
                  to={page.slug}
                >
                  {page.title}
                </NavLink>
                {subpage && subpage.length > 0 && (
                  <Children>
                    {subpage.map(({ title, slug, subpageId }) => (
                      <Child key={subpageId}>
                        <ChildLink
                          partiallyActive
                          activeClassName={activeClassName}
                          to={slug}
                        >
                          {title}
                        </ChildLink>
                      </Child>
                    ))}
                  </Children>
                )}
              </Li>
            ))}
          </List>
        )}
      </Nav>
    </>
  );
};

export default styled(BlockNav)``;
